export const MOST_POPULAR_RESOURCES = 'Most popular resources'
export const STUDENT_ACTIVITIES = 'Student activities'
export const MANAGE_YOUR_CLASSROOM = 'Manage your classroom'
export const TRY_SOMETHING_NEW = 'Try something new'
export const FEATURED_CONTENT = 'Featured Content'
export const STANDARDS_CONTENT = 'Standards Content'
export const TOP_PRIMARY = 'Top primary'
export const TOP_SECONDARY = 'Top secondary'
export const FEATURED_PUBLISHER_CONTENT = 'Featured publisher content'

// category id's
export const DEV_STUDENT_ACTIVITIES_ID = 'z7ipd7'
export const DEV_MANAGE_YOUR_CLASSROOM_ID = 'FdlBku'
export const DEV_TRY_SOMETHING_NEW_ID = 'KMgUg9'
export const DEV_FEATURED_CONTENT_ID = 'LgaKcy'
export const DEV_STANDARDS_CONTENT_ID = 'wVCieD'

export const PREPROD_STUDENT_ACTIVITIES_ID = 'HDn5fU'
export const PREPROD_MANAGE_YOUR_CLASSROOM_ID = 'IgbEkw'
export const PREPROD_TRY_SOMETHING_NEW_ID = 'hDr5eS'
export const PREPROD_FEATURED_CONTENT_ID = 'Ml6Ney'
export const PREPROD_STANDARDS_CONTENT_ID = 'Vf98nn'

export const PROD_STUDENT_ACTIVITIES_ID = 'J5JZhb'
export const PROD_MANAGE_YOUR_CLASSROOM_ID = 'L4H7be'
export const PROD_TRY_SOMETHING_NEW_ID = 'xzMydD'
export const PROD_FEATURED_CONTENT_ID = 'ZL7Q40'
export const PROD_STANDARDS_CONTENT_ID = 'CXwtja'

// german category ids
export const DEV_GERMAN_FEATURED_ID = 'P5Dwbn'
export const DEV_GERMAN_TOP_PRIMARY_ID = 'NzdpfB'
export const DEV_GERMAN_TOP_SECONDARY_ID = 'V7Dai0'
export const DEV_GERMAN_FEATURED_PUBLISHER_CONTENT_ID = 'cVpIiq'

export const PREPROD_GERMAN_FEATURED_ID = 'k9LZc8'
export const PREPROD_GERMAN_TOP_PRIMARY_ID = '1IgzjK'
export const PREPROD_GERMAN_TOP_SECONDARY_ID = '894HXX'
export const PREPROD_GERMAN_FEATURED_PUBLISHER_CONTENT_ID = 'FvXSjR'

export const PROD_GERMAN_FEATURED_ID = '3BPpiE'
export const PROD_GERMAN_TOP_PRIMARY_ID = 'eTf9cE'
export const PROD_GERMAN_TOP_SECONDARY_ID = 'XP2dgo'
export const PROD_GERMAN_FEATURED_PUBLISHER_CONTENT_ID = 'b4YmeO'

// norwegian category ids
export const DEV_NORWEGIAN_FEATURED_ID = '3xngh3'
export const DEV_NORWEGIAN_TOP_PRIMARY_ID = 'PPgle7'
export const DEV_NORWEGIAN_TOP_SECONDARY_ID = 'ZfD3b8'
export const DEV_NORWEGIAN_FEATURED_PUBLISHER_CONTENT_ID = 'baFQff'

export const PREPROD_NORWEGIAN_FEATURED_ID = 'TPtKic'
export const PREPROD_NORWEGIAN_TOP_PRIMARY_ID = 'jljdhO'
export const PREPROD_NORWEGIAN_TOP_SECONDARY_ID = 'cfmFk9'
export const PREPROD_NORWEGIAN_FEATURED_PUBLISHER_CONTENT_ID = 'ruHDig'

export const PROD_NORWEGIAN_FEATURED_ID = 'XXUAfa'
export const PROD_NORWEGIAN_TOP_PRIMARY_ID = 'Z4uvhV'
export const PROD_NORWEGIAN_TOP_SECONDARY_ID = 'qezljq'
export const PROD_NORWEGIAN_FEATURED_PUBLISHER_CONTENT_ID = '0xFajt'
